import React from 'react';
import type { ImageName } from '../../types';
import { imagePaths } from '../../assets';

export interface ImageProps {
  name: ImageName;
  width?: number | string;
  height?: number | string;
  className?: string;
  alt?: string;
  loading?: 'lazy' | 'eager';
}

export const Image: React.FC<ImageProps> = ({
  name,
  width,
  height,
  className = '',
  alt,
  loading = 'lazy',
}) => {
  const style: React.CSSProperties = {};

  if (width) {
    style.width = typeof width === 'number' ? `${width}px` : width;
  }

  if (height) {
    style.height = typeof height === 'number' ? `${height}px` : height;
  }

  return (
    <img
      src={imagePaths[name]}
      alt={alt || name}
      className={className}
      style={style}
      loading={loading}
    />
  );
};
